import CaseTabsApi from '../api/CaseTabsApi';

class CaseTabsService {
  public async getModuleSettings(caseId: string, moduleInstanceId: number) {
    return await CaseTabsApi.getModuleSettings(caseId, moduleInstanceId);
  }
}

export default new CaseTabsService();
